import {
  validateInfantsCountSchema,
  validateTripTypeSchema,
  validateCabinClass,
  validateProductTypeSchema,
  validateAdultsCountSchema,
  validateYouthCountSchema,
  validateChildrenCountSchema,
  validateDepartureAirport,
  validateArrivalAirport,
  validateCalendarSchema,
  validateIsFlexDatesSchema, // TODO: HP_FLIGHT_FLEX_DATES seti cleanup
  validateRoomCapacity
} from './validators'

const validateFlightsSchema = values => {
  const schemas = {
    tripType: values => validateTripTypeSchema(values),
    cabinClass: values => validateCabinClass(values),
    productType: values => validateProductTypeSchema(values),
    adultsCount: values => validateAdultsCountSchema(values),
    roomCount: values => validateRoomCapacity(values),
    youthsCount: values => validateYouthCountSchema(values),
    childrenCount: values => validateChildrenCountSchema(values),
    infantsCount: values => validateInfantsCountSchema(values),
    isFlexDates: values => validateIsFlexDatesSchema(values),
    flights: {
      departureAirport: (item, errors) =>
        validateDepartureAirport(
          {
            infantsCount: values.infantsCount,
            departureAirport: item.departureAirport,
            otherAirport: item.arrivalAirport
          },
          errors
        ),
      arrivalAirport: (item, errors) =>
        validateArrivalAirport(
          {
            infantsCount: values.infantsCount,
            arrivalAirport: item.arrivalAirport,
            otherAirport: item.departureAirport
          },
          errors
        ),
      departureDate: item =>
        validateCalendarSchema(
          {
            departureDate: item.departureDate,
            arrivalDate: item.arrivalDate,
            tripType: values.tripType,
            calendarOpen: values.calendarOpen
          },
          'departureDate'
        ),
      arrivalDate: item =>
        validateCalendarSchema(
          {
            departureDate: item.departureDate,
            arrivalDate: item.arrivalDate,
            tripType: values.tripType,
            calendarOpen: values.calendarOpen
          },
          'arrivalDate'
        )
    }
  }
  return schemas
}

export default validateFlightsSchema
